/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_01_Detail_Tournament_1_HeadingInputs */

const en_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup and the kinetic chain`)
};

const es_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup y la cadena cinética`)
};

const de_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufbau und die kinetische Kette`)
};

const zh_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备姿势与动力链`)
};

const ar_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإعداد والسلسلة الحركية`)
};

const fr_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en place et chaîne cinétique`)
};

const vi_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup và chuỗi động lực`)
};

const sw_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandalizi na mnyororo wa kinetiki`)
};

const th_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การจัดท่าก่อนตีกับห่วงโซ่การเคลื่อนไหว`)
};

const bs_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup i kinetički lanac`)
};

const ja_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セットアップと運動連鎖`)
};

const ko_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`셋업과 키네틱 체인`)
};

const pt_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparação e cadeia cinética`)
};

const it_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il setup e la catena cinetica`)
};

const sv_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppställningen och den kinetiska kedjan`)
};

const nl_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opstelling en de kinetische keten`)
};

const da_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opstillingen og den kinetiske kæde`)
};

const nb_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppstillingen og den kinetiske kjeden`)
};

const fi_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähtöasento ja kineettinen ketju`)
};

const pl_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustawienie a łańcuch kinetyczny`)
};

const ru_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исходная позиция и кинетическая цепь`)
};

const tr_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hazırlık ve kinetik zincir`)
};

const hi_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटअप और काइनेटिक श्रृंखला`)
};

const id_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup dan rantai kinetik`)
};

const ms_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persediaan dan rantaian kinetik`)
};

const cs_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postavení a kinetický řetězec`)
};

const el_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η προετοιμασία και η κινητική αλυσίδα`)
};

const he_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עמידת הפתיחה והשרשרת הקינטית`)
};

const af_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opstelling en die kinetiese ketting`)
};

const hu_method_content_step_01_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az alapállás és a kinetikus lánc`)
};

/**
* | output |
* | --- |
* | "Setup and the kinetic chain" |
*
* @param {Method_Content_Step_01_Detail_Tournament_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_01_detail_tournament_1_heading = /** @type {((inputs?: Method_Content_Step_01_Detail_Tournament_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_01_Detail_Tournament_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "de") return de_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "th") return th_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "it") return it_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "da") return da_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "id") return id_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "el") return el_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "he") return he_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "af") return af_method_content_step_01_detail_tournament_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_01_detail_tournament_1_heading(inputs)
	return en_method_content_step_01_detail_tournament_1_heading(inputs)
});